<template>
    <div class="max-w-3xl mx-auto bg-white border border-gray-300 rounded-lg shadow-lg px-6 py-4 mt-5">

        <div v-if="loading" class="flex justify-center items-center h-32">
                <div class="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-opacity-75"></div>
                <p class="ml-3 text-gray-600">Fetching details...</p>
        </div>

        <div class="py-4" v-else>
            <div class="text-gray-700 text-2xl font-bold text-left">Select Beneficiary</div>
            <p class="text-gray-700 text-left">Please select the beneficiary or search the beneficiary</p>


            <div class="mt-4">
                <input type="text" v-model="searchQuery" placeholder="Search by name"
                    class="w-full px-3 py-2 border rounded" />
            </div>

            <table class="w-full border-collapse mt-5">
                <thead>
                    <tr class="bg-gray-200 text-gray-800">
                        <th class="p-3 rounded-tl-lg">Name</th>
                        <th class="p-3">Account Number</th>
                        <th class="p-3">Bank</th>
                        <th class="p-3"></th>
                        <th class="p-3 rounded-tr-lg"></th>
                    </tr>
                </thead>
                <tbody v-if="filteredBeneficiaries.length">
                    <tr v-for="beneficiary in filteredBeneficiaries" :key="beneficiary.id"
                        class="bg-white shadow-md rounded-lg">
                        <td class="p-3">{{ beneficiary.name }}</td>
                        <td class="p-3">{{ beneficiary.accountNumber }}</td>
                        <td class="p-3">{{ beneficiary.bank }}</td>
                        <td class="p-3">
                            <button @click="redirectToPayment(beneficiary)"
                                class="px-6 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-blue-700">
                                Payment
                            </button>
                        </td>
                        <td class="p-3">
                            <button
                                class="px-6 py-2 bg-red-700 text-white text-sm font-medium rounded-md hover:bg-red-500">
                                Delete
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="4" class="p-4 text-center text-gray-500">No beneficiary available</td>
                    </tr>
                </tbody>
            </table>


        </div>
    </div>
</template>

<script>

// import { apiRequest } from '@/api';

export default {
    name: "BeneficiaryDetails",
    data() {
        return {
            searchQuery: "",
            loading : false,
            beneficiaries: [
                { id: 1, name: "John Doe", accountNumber: "123456789", bank: "DMC Bank" },
                { id: 2, name: "Jane Smith", accountNumber: "987654321", bank: "XYZ Bank" },
                { id: 3, name: "Emily Brown", accountNumber: "456123789", bank: "PQR Bank" },
            ],
        };
    },
    props: {
        user: Object
    },
    computed: {
        filteredBeneficiaries() {
            return this.beneficiaries.filter(beneficiary =>
                beneficiary.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    created() {
        
    },
    methods: {
        redirectToPayment(beneficiary){
            sessionStorage.setItem('selectedBeneficiary', JSON.stringify(beneficiary));
            this.$router.push('/payment');
        }
        
    }
};
</script>
<style scoped>

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>